import { render, staticRenderFns } from "./onboardform.vue?vue&type=template&id=0dd152fa&scoped=true"
import script from "./onboardform.vue?vue&type=script&lang=js"
export * from "./onboardform.vue?vue&type=script&lang=js"
import style0 from "./onboardform.vue?vue&type=style&index=0&id=0dd152fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd152fa",
  null
  
)

export default component.exports